import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AppDropdownComponent),
            multi: true
        }
    ]
})
export class AppDropdownComponent implements ControlValueAccessor {
    @Input() items: any[] = [];
    @Input() displayField: string = 'name';
    @Input() valueField: string = 'id';
    @Input() placeholder: string = 'Select...';
    @Input() disabled: boolean = false;
    @Output() valueChange = new EventEmitter<any>();

    selectedValue: any = null;

    onChange: any = () => { };
    onTouched: any = () => { };

    writeValue(value: any): void {
        this.selectedValue = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    onValueChange(value: any) {
        this.selectedValue = value;
        this.onChange(value);
        this.valueChange.emit(value);
        this.onTouched();
    }

    onNativeChange(event: Event) {
        event.preventDefault();
        event.stopPropagation();
    }
}